import proxy from "../proxy.json";

const allowlist = proxy.impersonatePostMessageOriginAllowlist ?? {};
const HOST_SUFFIXES = Array.isArray(allowlist.hostSuffixes) ? allowlist.hostSuffixes : [];
const HTTP_IP_HOSTS_ANY_PORT = Array.isArray(allowlist.httpIpHostsAnyPort)
  ? allowlist.httpIpHostsAnyPort
  : [];
const LOCALHOST_HOSTS_ANY_PORT = Array.isArray(allowlist.localhostHostsAnyPort)
  ? allowlist.localhostHostsAnyPort
  : [];

function isHostAllowedBySuffix(hostname, suffixes) {
  const h = hostname.toLowerCase();
  return suffixes.some((suffix) => {
    const s = suffix.toLowerCase();
    return h === s || h.endsWith(`.${s}`);
  });
}

function isHttpIpOriginAllowed(origin) {
  let url;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.protocol !== "http:") return false;
  return HTTP_IP_HOSTS_ANY_PORT.includes(url.hostname);
}

function isLocalhostOriginAllowed(origin) {
  let url;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return false;
  return LOCALHOST_HOSTS_ANY_PORT.includes(url.hostname);
}

function isSuffixOriginAllowed(origin) {
  let url;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return false;
  return isHostAllowedBySuffix(url.hostname, HOST_SUFFIXES);
}

export function isImpersonatePostMessageOriginAllowed(origin) {
  if (typeof origin !== "string" || origin.length === 0) return false;
  if (isSuffixOriginAllowed(origin)) return true;
  if (isHttpIpOriginAllowed(origin)) return true;
  if (isLocalhostOriginAllowed(origin)) return true;
  return false;
}

export function getImpersonateHandshakePostMessageTarget() {
  const fromEnv = process.env.REACT_APP_IMPERSONATE_OPENER_ORIGIN;
  if (typeof fromEnv === "string" && fromEnv.trim().length > 0) {
    const trimmed = fromEnv.trim();
    if (isImpersonatePostMessageOriginAllowed(trimmed)) {
      return trimmed;
    }
    return "";
  }
  try {
    const o = globalThis.opener?.location?.origin;
    if (o && isImpersonatePostMessageOriginAllowed(o)) {
      return o;
    }
  } catch {
    /**/
  }
  return "";
}
